module.exports = __webpack_public_path__ + "static/media/settings-icon.93aa9a3b.svg";